export const ALL_CACHE_KEYS = 'cache:all-keys';
export const CACHE_VALUE_DELIMITER = '|';
export const DOT = '.';
